import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useAllPipelinesQueryV1(organizationUnitId?: string | Ref<string>, ) {
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>(organizationUnitId)
	const result = {
		organizationUnitId: _organizationUnitId,
		...useQuery(() => new q.AllPipelinesQueryV1(_organizationUnitId.value))
	}
	return {
		...result,
		runAllPipelinesQueryV1: result.run,
		modelAllPipelinesQueryV1: result.model,
	}
}

export function usePipelineDataPreviewQueryV1(pipelineId?: string | Ref<string>, ) {
	const _pipelineId = isRef<string>(pipelineId) ? pipelineId : ref<string>(pipelineId)
	const result = {
		pipelineId: _pipelineId,
		...useQuery(() => new q.PipelineDataPreviewQueryV1(_pipelineId.value))
	}
	return {
		...result,
		runPipelineDataPreviewQueryV1: result.run,
		modelPipelineDataPreviewQueryV1: result.model,
	}
}

export function usePipelineDetailsQueryV1(pipelineId?: string | Ref<string>, ) {
	const _pipelineId = isRef<string>(pipelineId) ? pipelineId : ref<string>(pipelineId)
	const result = {
		pipelineId: _pipelineId,
		...useQuery(() => new q.PipelineDetailsQueryV1(_pipelineId.value))
	}
	return {
		...result,
		runPipelineDetailsQueryV1: result.run,
		modelPipelineDetailsQueryV1: result.model,
	}
}

export function usePipelinePropertyNamesQueryV1(pipelineId?: string | Ref<string>, ) {
	const _pipelineId = isRef<string>(pipelineId) ? pipelineId : ref<string>(pipelineId)
	const result = {
		pipelineId: _pipelineId,
		...useQuery(() => new q.PipelinePropertyNamesQueryV1(_pipelineId.value))
	}
	return {
		...result,
		runPipelinePropertyNamesQueryV1: result.run,
		modelPipelinePropertyNamesQueryV1: result.model,
	}
}

export function usePipelinesDashboardQueryV1(organizationUnitId?: string | Ref<string>, ) {
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>(organizationUnitId)
	const result = {
		organizationUnitId: _organizationUnitId,
		...useQuery(() => new q.PipelinesDashboardQueryV1(_organizationUnitId.value))
	}
	return {
		...result,
		runPipelinesDashboardQueryV1: result.run,
		modelPipelinesDashboardQueryV1: result.model,
	}
}

export function usePipelineTriggerQueryV1(pipelineId?: string | Ref<string>, ) {
	const _pipelineId = isRef<string>(pipelineId) ? pipelineId : ref<string>(pipelineId)
	const result = {
		pipelineId: _pipelineId,
		...useQuery(() => new q.PipelineTriggerQueryV1(_pipelineId.value))
	}
	return {
		...result,
		runPipelineTriggerQueryV1: result.run,
		modelPipelineTriggerQueryV1: result.model,
	}
}

